import React from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors, boxShadows } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {},
  titleTextContainer: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.grey3,
  },
  cardContent: {
    borderRadius: '8px',
    boxShadow: boxShadows.sideCard,
    border: `solid 1px ${colors.border.grey}`,
    padding: 15,
  },
  cardTitle: {
    display: 'flex',
    marginBottom: 16,
  },
  subTitle: {
    marginBottom: 15,
  },
  titleLinkContainer: {
    margin: 'auto',
    marginRight: 0,
    cursor: 'pointer',
  },
}));

const StubPageSideCard = ({
  className,
  classNameContent,
  children,
  title,
  titleActionComponent,
  isNoShow,
  subTitle,
}) => {
  const classes = useStyles();
  if (isNoShow) {
    return null;
  }

  return (
    <div className={cn(classes.root, className)}>
      <div className={classes.cardTitle}>
        <div className={classes.titleTextContainer}>{title}</div>
        <div className={classes.titleLinkContainer}>{titleActionComponent}</div>
      </div>
      <div className={classes.subTitle}>{subTitle}</div>
      <div className={cn(classes.cardContent, classNameContent)}>{children}</div>
    </div>
  );
};

StubPageSideCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  subTitle: oneOfType([PropTypes.string, PropTypes.node]),
  titleActionComponent: PropTypes.node,
  isNoShow: PropTypes.bool,
};

export default StubPageSideCard;
